import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDnveJubsV-1fz-eV6pv1r7qQMJJETOZYo",
  authDomain: "kryptonian-ecom.firebaseapp.com",
  projectId: "kryptonian-ecom",
  storageBucket: "kryptonian-ecom.firebasestorage.app",
  messagingSenderId: "915463734784",
  appId: "1:915463734784:web:ca810f240ffceb5019fae5",
  measurementId: "G-BPV792GYTE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export default app;